import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

export class PplDialogRef<C = any, R = any> {
  readonly id: string;
  afterClosed: () => Observable<R>;
  afterOpened: () => Observable<void>;
  close: (value?: R) => void;
  canMinimize: () => boolean;
  isMinimized: () => boolean;
  afterMinimized: () => Observable<void>;
  afterMaximized: () => Observable<void>;
  minimize?: () => void;
  maximize?: () => void;
  componentInstance: C;
  move: (data: PplDialogMoveData) => void;
}

export const PPL_DIALOG_DATA = new InjectionToken<{}>('PPL_DIALOG_DATA');

export interface PplDialogMoveData {
  leftX: number;
  topY: number;
}
